<template>
<div>  
   <!-- partner Section -->
    <section class="page-section bg-light-orange" id="partnersection">
        <!-- muncul pas gede aja -->
        <div class="container d-sm-none d-md-block d-none d-sm-block">
            <h1 class="text-center mt-0 section-title" v-t="{path: 'textPartners1'}"></h1>
            <hr class="divider my-4" style="visibility:hidden;margin:0.5rem!important;">
            <div dir="ltr" class="d-flex flex-row flex-wrap justify-content-center align-items-center">
                <a v-for="pub in lists" :href="pub.url" target="_blank" rel="noopener noreferrer">
                    <img v-lazy="pub.img" class="partner-logo" />
                    <span v-lazy:background-image="pub.img"></span>
                </a>
            </div>
            <hr class="divider light my-4 border-light-orange" />
        </div>

        <!-- muncul pas kecil aja -->
        <div class="container d-block d-sm-none padding-bottom-mini">
            <h1 class="text-center mt-0 section-title" v-t="{path: 'textPartners1'}"></h1>
            <hr class="divider my-4"  style="visibility:hidden;margin:1.5rem!important;">
            <div dir="ltr" class="d-flex flex-row flex-wrap justify-content-center align-items-center">
                <a v-for="listIndex in listsMobileOnlyIndex" :href="lists[listIndex].url" target="_blank" rel="noopener noreferrer">
                    <img v-lazy="lists[listIndex].img" class="partner-logo-mini" />
                    <span v-lazy:background-image="lists[listIndex].img"></span>
                </a>
            </div>
        </div>
    </section>
</div>
</template>

<script>
import { createImageObject } from '@/utils/utils';

export default {
   name: 'PartnerSection' ,
   data() {
       return {
        lists: [
            {
                img: createImageObject('./assets/img/partner/par1.png'),
                url: 'https://learn-quran.co/link/?url=https://ybmpln.org/',
            },
            {
                img: createImageObject('./assets/img/partner/par2.png'),
                url: 'https://learn-quran.co/link/?url=https://www.instagram.com/fusi.foundation/',
            },
            {
                img: createImageObject('./assets/img/partner/par3.png'),
                url: 'https://learn-quran.co/link/?url=https://www.instagram.com/kemenpar.ri/',
            },
            {
                img: createImageObject('./assets/img/partner/par4.png'),
                url: 'https://learn-quran.co/link/?url=https://baznas.go.id/',
            },
            {
                img: createImageObject('./assets/img/partner/par5.png'),
                url: 'https://learn-quran.co/link/?url=https://innovation.ui.ac.id/',
            },
        ],
        listsMobileOnlyIndex: [1, 2, 0, 3, 4],
       }
   },
    mounted() {
       this.$nextTick(() => {
            // alert('partner section finish loaded')
            this.$emit('isServiceSection', 'serviceSectionActive')
        });
    },
}
</script>

<style scoped>
.rounded-lg {
    border-radius: .5rem!important;
}
img {
    max-height:5rem;    
    max-width: 100%;
    transition: 0.3s;
}

img:hover {    
    opacity: 0.5;
}

.section-title {
    font-family: 'QuattrocentoRegular', 'Rubik', sans-serif;
    /* font-weight: 0!important; */
    color:#053448;
}

#publishedsection {
    padding-bottom: 0.1rem!important;
}

.padding-bottom-mini {
    padding-bottom: 3rem;
}

/* partner */
.partner-logo-mini {
    /* max-width: 6.5rem;
    margin-right:1rem; */
    padding: 0.35rem;
}

/* .partner-logo-mini:last-child {
    margin-right: 0;
} */

.no-margin-right {
    margin-right: 0!important;
}

.no-padding {
    padding: 0;
}

.partner-logo {
    margin: 0.5rem;
    margin-right: 2rem;
}

.partner-logo:last-child {
    /* margin-right: 0; */
}

.bg-light-orange {
    background-color: #fff1ed !important;
}
.border-light-orange {
    border-color: #fff1ed !important;
}
</style>
